// import React from 'react';
import NewsItem from './NewsItem/NewsItem';
import styles from './NewsList.module.scss';
import { useSelector } from 'react-redux';
import SkeletonNewsBlock from '../../../../universal_components/Skeletots/SkeletonNewsBlock';

const NewsList = ({ data }) => {
  const newsList = useSelector((state) => (data === 'events' ? state.news.events : state.news.media));
  const filterYear = useSelector((state) =>
    data === 'events' ? state.news.filterYearEvents : state.news.filterYearMedia,
  );

  const filteredNews = filterYear
    ? newsList.filter((news) => new Date(news.date_to_show).getFullYear() === filterYear)
    : newsList;

  if (newsList.length === 0) {
    return (
      <ul className={styles.list}>
        {Array.from({ length: 12 }).map((_, index) => (
          <SkeletonNewsBlock key={index} width={240} height={243} />
        ))}
      </ul>
    );
  }

  return (
    <ul className={styles.list}>
      {filteredNews.map((item) => {
        return (
          <NewsItem
            key={item.id}
            id={item.id}
            title={item.title}
            img={item.images[0]?.cropped_image}
            date={item.date_to_show}
          />
        );
      })}
    </ul>
  );
};

export default NewsList;
